import { FunctionComponent } from "react";

const DealershipPage: FunctionComponent = () => {
  return (
    <div></div>
  );
}

export default DealershipPage;
